"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _core = require("@material-ui/core");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TimerBar = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(TimerBar, _StoreComponent);

  var _super = _createSuper(TimerBar);

  function TimerBar(props) {
    var _thisSuper, _this2;

    (0, _classCallCheck2["default"])(this, TimerBar);
    _this2 = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "update", function () {
      var elapsedTime = _this2.props.startTime ? (0, _now["default"])() - _this2.props.startTime - _this2.props.startDelay : 0;
      var scale = elapsedTime / _this2.props.duration;

      if (_this2.props.running && !_this2.props.editorMode) {
        if (scale < 1) {
          _this2.setState({
            value: scale * 100
          });

          if (_DeviceInfoHelper["default"].isInternetExplorer()) {
            _this2.requestId = setTimeout(_this2.update, 200);
          } else {
            _this2.requestId = window.requestAnimationFrame ? window.requestAnimationFrame(_this2.update) : setTimeout(_this2.update, 100);
          }
        } else {
          _this2.props.onTimeOver();
        }
      }
    });
    _this2.state = {
      value: 0
    };
    _this2.ref = /*#__PURE__*/_react["default"].createRef();
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this2), (0, _getPrototypeOf2["default"])(TimerBar.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['quiz', 'currentTheme']
    }]);
    return _this2;
  }

  (0, _createClass2["default"])(TimerBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.log('timerbar for question number: ' + this.props.questionNumber);
      console.log('timerbar with start time: ' + this.props.startTime);
      this.requestId = window.requestAnimationFrame ? window.requestAnimationFrame(this.update) : setTimeout(this.update, 100);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this = this;

      if (!prevProps.running && this.props.running && !this.props.editorMode) {
        setTimeout(function () {
          _this.update();
        }, Math.max(300, this.props.startDelay));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_DeviceInfoHelper["default"].isInternetExplorer() && window.cancelAnimationFrame) {
        window.cancelAnimationFrame(this.requestId);
      } else {
        window.clearTimeout(this.requestId);
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(TimerBar.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      var theme = null;

      if (this.state.quiz && this.state.currentTheme in this.state.quiz) {
        theme = this.state.quiz[this.state.currentTheme];
      }

      var defaultTheme = this.state.quiz ? this.state.quiz["default"] : null;
      return {
        backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(theme, 'quizTimer', defaultTheme, 'quizTimer', _ColorHelper.COLOR.BLACK),
        opacity: this.state.value > 0
      };
    }
  }, {
    key: "render",
    value: function render() {
      var style = this.getStyles();
      var ColorLinearProgress = (0, _withStyles["default"])({
        bar: {
          width: '100%'
        },
        barColorPrimary: {
          backgroundColor: style.backgroundColor,
          opacity: style.opacity
        }
      })(_core.LinearProgress);
      return /*#__PURE__*/_react["default"].createElement(ColorLinearProgress, {
        className: this.props.className,
        value: this.state.value,
        variant: 'determinate',
        thickness: 5
      });
    }
  }]);
  return TimerBar;
}(_StoreComponent2["default"]);

TimerBar.propTypes = {
  questionNumber: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  // the duration in milliseconds
  className: _propTypes["default"].string,
  onTimeOver: _propTypes["default"].func,
  running: _propTypes["default"].bool,
  startDelay: _propTypes["default"].number,
  editorMode: _propTypes["default"].bool
};
TimerBar.defaultProps = {
  startDelay: 800
};
var _default = TimerBar;
exports["default"] = _default;